<template>
  <div id="userLogin">
    <div>
      <h2>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#se-icon-elephant"></use>
        </svg>
        <span>请输入需要更换的SIM卡号</span>
      </h2>
      <form>
        <div class="formLine">
          <se-autocomplete v-model="userInfo.oldIccid" :fetchsuggestions="querySearch" @select="handleSelect"
            placeholder="SIM卡号/ICCID号"></se-autocomplete>
        </div>
        <div class="formLine">
          <mt-button type="primary" size="large" @click.prevent="chgCardQueryHandler">换卡</mt-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { wxRequest } from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
export default {
  components: { SeAutocomplete },
  data() {
    return {
      code: null,
      userInfo: {
        oldIccid: "",
        takeNickname: "",
        takePhone: "",
        takeAddress: "",
        disposeState: "",
        disposeRemark: "",
        changeCmccSim: 6,
        changeCmccSimName: "",
        pcaAddress: "",
      },
    };
  },
  created() {
    var appid = 'wxb4bff16244869bed';

    var redirectUrl = window.location.href;
    var index = redirectUrl.indexOf("code");
    redirectUrl = encodeURIComponent(redirectUrl);
    if (index < 0) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    } else {
      var search = window.location.search;
      console.log("search = ", search);
      var startIndex = search.indexOf("code");
      var endIndex = search.indexOf("&", startIndex);
      var str = search.slice(startIndex, endIndex);
      var code = str.slice(str.indexOf("=") + 1);
      this.code = code;
      console.log("code = ", code);
      if (this.$route.query.iccid) {
        this.userInfo.oldIccid = this.$route.query.iccid;
      }
    }
  },
  methods: {
    querySearch(queryString, cb) {
      var listAll = this.getAutoCompleteData("chgIccidList");
      var results = queryString
        ? listAll.filter(this.createFilter(queryString))
        : listAll;
      cb(results);
    },
    createFilter(queryString) {
      return (listAll) => {
        return listAll.indexOf(queryString) == 0;
      };
    },
    handleSelect(item) {
      this.userInfo.oldIccid = item;
    },

    //获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },

    chgCardQueryHandler() {
      /**   换卡判断       **/
      let fd = new FormData();
      fd.append("iccid", this.userInfo.oldIccid);
      localStorage.setItem("recordLoginText", this.userInfo.oldIccid);
      if (this.code) {
        let data = {
          requestId: this.userInfo.oldIccid,
          code: "1",
          isCode: 1,
        };
        wxRequest("sim/bind", data, "get").then((res) => {
          if (res.data.code == "200") {
            const record = res.data.data;
            const iccid = record.iccid;
            localStorage.setItem("isShowApp", record.isShowApp);
            localStorage.setItem("isShowAppMenu", record.isShowApp);


            localStorage.setItem("PayImgUrl", record.imgUrl);
            localStorage.setItem("payPrice", record.payPrice);

            localStorage.setItem("isAutoHome", 1); // 1表示自动跳转到 firstHome
            localStorage.setItem("isCode", true);
            localStorage.setItem("mobile", record.mobile);
            localStorage.setItem("userPhone", record.userPhone); // 用户绑定得手机号
            localStorage.setItem("supplierTypeName", record.supplierTypeName);
            localStorage.setItem("wxHeadImg", record.wxHeadImg);
            localStorage.setItem("wxNickName", record.wxNickName);
            localStorage.setItem("supplierName", record.supplierName);
            localStorage.setItem("intoNo", record.intoNo);
            localStorage.setItem("iccid", record.iccid);
            localStorage.setItem("openId", record.openId);
            localStorage.setItem("virtualNo", record.virtualNo);
            localStorage.setItem("isBindPhone", record.isBindPhone);
            localStorage.setItem("tuiPrice", record.tuiPrice); // 赠送金余额
            localStorage.setItem("firstLogin", 1);
            localStorage.setItem("basePkgGroup", record.basePkgGroup);
            this.$store.state.supplierCode = res.data.data.supplierCode;
            this.$store.state.iccid = iccid;
            this.$store.commit("setIccid", iccid);
            localStorage.setItem("newHome", 1);
            const _data = {
              requestId: iccid,
              code: this.code,
              userPhone: record.userPhone,
            };
            wxRequest("sim/bindIccid/appid", _data, "get").then((res) => {
              if (res.data.code == "200") {
                this.$router.push({
                  name: "userChgCardPay",
                  query: {
                    oldIccid: this.userInfo.oldIccid,
                    changeCmccSim: 2,
                  },
                });
              } else {
                this.$dialog.alert({ title: "提示", message: res.data.message });
              }

            })


          } else {
            this.$dialog.alert({ title: "提示", message: res.data.message });
          }
        });
      }

      /**     换卡判断   end    **/
    },
  },

  mounted() { },
};
</script>
